import { cloneElement, Children, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const useOutsideClick = (ref, callback, isActive) => {
  useEffect(() => {
    const handleOutsideClick = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };

    if (isActive) document.addEventListener('mousedown', handleOutsideClick);
    else document.removeEventListener('mousedown', handleOutsideClick);

    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [ref, isActive, callback]);
};

const OutsideClickHandler = ({
  isActive = true,
  callback = () => {},
  children,
}) => {
  const ref = useRef(null);
  useOutsideClick(ref, callback, isActive);
  return Children.map(children, child => cloneElement(child, { ref }));
};

OutsideClickHandler.propTypes = {
  isActive: PropTypes.bool,
  callback: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default OutsideClickHandler;
